export default "__VITE_ASSET__AS4dgCax__"